type ModalTitleProps = {
  title: string;
};

export const ModalTitle: React.FC<ModalTitleProps> = ({ title }) => {
  return (
    <div className="flex-1 flex flex-col justify-center items-start">
      <div
        className="text-gray-400 text-lg font-medium break-words"
        style={{ fontFamily: 'var(--ep-font-avenir)', lineHeight: 1.2 }}
      >
        {title}
      </div>
    </div>
  );
};
